// extracted by mini-css-extract-plugin
export default {"alarm":"index_alarm_dVfM4","textLine":"index_textLine_ehfaz"};